import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import {
    ApontamentoAmostraParams,
    ApontamentoClienteParams,
    ApontamentoCommonFields,
    ApontamentoImages,
    ApontamentoObservacao,
    ApontamentoParamItem,
    ApontamentoResultado,
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields";
import ApontamentoPontosdeColetas from "entity/Indicador/components/apontamento/fields/ApontamentoPontosdeColetas";

import { useEffect, useMemo } from "react";
import IndicadorEntity from "..";
import FormRow from "components/form/FormRow";
import SelectInput from "components/form/input/SelectInput";
import { useForm } from "react-final-form";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import Operador from "entity/Operador";

export default function EditFields({ visita, TipoClass }) {
    const [tipo, setTipo] = useTipoApontamento();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const params = useMemo(() => visita.cliente.getParams(IndicadorEntity, "Manual", TipoClass), [visita.cliente]);

    const [apontamento] = useFieldValue();
    const form = useForm();

    useEffect(() => {
        if (tipo !== "Manual") {
            setTipo("Manual");
        }
    }, [setTipo, tipo]);

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = IndicadorEntity.calcConformidade(apontamento, params);
            form.change("conformidade", IndicadorEntity.calcConformidade(apontamento, params));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, params]);

    return (
        <>
            <ApontamentoCommonFields
                visita={visita}
                TipoClass={TipoClass}
                showTrator={false}
                showImplemento={false}
                showFrente={false}
                showVariedade
            />

            <ApontamentoAmostraParams tipoFixedValue="Manual">
                <FormRow>
                    <EntitySearchInput
                        name="operador"
                        label="Operador"
                        EntityClass={Operador}
                        extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)}
                    />
                </FormRow>
                <FormRow>
                    <SelectInput name="turno" label="Turno" options={["A", "B", "C"]} required />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="Metros por Ponto (m):">
                            {params.metrosPorPonto}
                        </ApontamentoParamItem>
                        <ApontamentoParamItem label="Meta (%):">{params.meta}</ApontamentoParamItem>
                    </>
                ) : null}
                {apontamento && apontamento.talhao ? (
                    <ApontamentoParamItem label="Área do Talhão:">{apontamento.talhao.area}</ApontamentoParamItem>
                ) : null}
            </ApontamentoClienteParams>
            <ApontamentoPontosdeColetas visita={visita}>
                <TextInput type="number" name="valor" label="Valor (cm)" />
            </ApontamentoPontosdeColetas>
            {/* <ApontamentoColetas visita={visita}>
                <TextInput type="number" name="espacamento" label="Espaçamento" />
                <TextInput name="conforme" label="Conforme" disabled />
            </ApontamentoColetas> */}

            <ApontamentoResultado />
            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
